module.exports = __webpack_public_path__ + "static/srdp-logo-blanc.923baa1f.svg";